export const state = () => ({
    clients: {},
});
